"use strict";
function resolve(value) {
  /*jshint validthis:true */
  if (value && typeof value === 'object' && value.constructor === this) {
    return value;
  }

  var Promise = this;

  return new Promise(function(resolve) {
    resolve(value);
  });
}

exports.resolve = resolve;


//////////////////
// WEBPACK FOOTER
// ./~/es6-promise/dist/commonjs/promise/resolve.js
// module id = 180
// module chunks = 0